import { generate } from '@ant-design/colors';
import { defaultPresetColors } from '../seed';
import genColorMapToken from '../shared/genColorMapToken';
import genCommonMapToken from '../shared/genCommonMapToken';
import { generateBgPalettes, generateColorPalettes, generateTextAlphaPalettes } from './palettes';
export default function derivative(token) {
    const colorPalettes = Object.keys(defaultPresetColors)
        .map((colorKey) => {
        const colors = generate(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i) => {
            prev[`${colorKey}-${i + 1}`] = colors[i];
            return prev;
        }, {});
    })
        .reduce((prev, cur) => {
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    const colorBgBase = token.colorBgBase || '#fff';
    const colorTextBase = token.colorTextBase || '#000';
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), { colorBgBase,
        colorTextBase }), genColorMapToken(Object.assign(Object.assign({}, token), { colorBgBase, colorTextBase }), {
        generateColorPalettes,
        generateBgPalettes,
        generateTextAlphaPalettes,
    })), genCommonMapToken(token));
}
